import { FormattedMessage, useIntl } from "react-intl";
import Toast from "common/core-ui/Toast";
import BaseLinkOrButton from "common/core-ui/BaseLinkOrButton";
import styles from "./SurveyToast.module.scss";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

interface SurveyToastProps {
  selfClose: () => void;
  onInteract: () => void;
  href: string;
}

export default function SurveyToast({
  onInteract,
  href,
  selfClose,
}: SurveyToastProps) {
  const intl = useIntl();
  const location = useLocation();
  const title = intl.formatMessage({
    defaultMessage: "We Value Your Feedback!",
  });
  const body = intl.formatMessage({
    defaultMessage:
      "Please take 2 minutes to share your experience with this page.",
  });

  useEffect(() => {
    if (location.pathname !== "/my-courses") {
      selfClose();
    }
  }, [location, selfClose]);

  return (
    <Toast
      onClose={onInteract}
      title={title}
      takeFocus={false}
      startCol={
        <div
          className={styles.thoughtCloud}
          role="img"
          aria-label={intl.formatMessage({ defaultMessage: "Thought Cloud" })}
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        >
          💭
        </div>
      }
    >
      {body}
      <div>
        <BaseLinkOrButton href={href} className="vst-link" onClick={onInteract}>
          <FormattedMessage defaultMessage="Give Feedback" />
        </BaseLinkOrButton>
      </div>
    </Toast>
  );
}
